const navigation = document.querySelector('.navigation')
const menuToggle = document.querySelector('.toggle-menu')
const body = document.querySelector('body');

if (navigation && menuToggle) {
    menuToggle.addEventListener('click', event => {
        event.preventDefault()
        navigation.classList.toggle('active')
        body.classList.toggle('menu-open')
    })
}